import { orderStatuses } from "../../static_data/orderStatuses";
import { Order } from "../../types";
import {isDeleted} from "../order/isDeleted";

export const filterActiveOrders = (orders:Order[]) => {
    return orders.filter(order => !isDeleted(order));
}